import React, { useContext, useState } from 'react'
import { Alert } from 'components'
import { Button, Switch } from 'components/Form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CreateBatteryStyles } from './Style'
import { assignAssessmentToSchoolClassFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'

const AssignAssessmentAlert2 = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const [removeGroupAffiliation, setRemoveGroupAffiliation] = useState(false)

    const { mutateAsync: assignAssessmentToSchoolClass, isPending } = useMutation({
        mutationFn: assignAssessmentToSchoolClassFetch,
        onSuccess: () => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries({ queryKey: assessmentOptions.queryKey })
            toast(" העדכון בוצע בהצלחה", toastConfig)
        }
    })

    const handleAssign = () => {
        assignAssessmentToSchoolClass({ remove_group: removeGroupAffiliation, assessment_ids: selectedAssessments })
    }

    return (
        <Alert
            systemUI
            title={"שיוך מבדקים לכיתת האם"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div>
                    {"המבדקים שנבחרו יחזרו להיות משויכים לכיתת האם"}
                </div>
                {""}
                <Switch
                    input={{
                        value: removeGroupAffiliation,
                        onChange: setRemoveGroupAffiliation
                    }}
                    label="האם לבטל את שיוך הקבוצה מהתלמיד?" />
                <div>
                    <Button
                        loading={isPending}
                        disabled={isPending}
                        action={handleAssign}
                        color="thirdly"
                        label="עדכון"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default AssignAssessmentAlert2